import { Image } from "../generic/image.model";

export class AddOn {
  id: number;
  name: string;
  description: string;
  image: Image;
}